module.exports = __webpack_public_path__ + "static/media/Novarese_Bold.648fa226.svg";